
































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Remarks extends Vue {
  @Prop() readonly doc!: any;
}
